import React, { useEffect } from "react";
import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import ProductShowcase from "../../components/cultivars/Avgas/ProductShowcase";
import FeatureHighlight from "../../components/cultivars/FeatureHighlight";
import Cta from "../../components/Cta";
import CultivarDisplay from "../../components/cultivars/CultivarDisplay";
import { Helmet } from 'react-helmet';


const Avgas = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
     <Helmet>
        <title>Avgas Cultivar - BeyondBloom™</title>
        <meta name="description" content="Discover Avgas, a premium cultivar from BeyondBloom™. High-quality growth, innovation, and excellence in every bloom." />
        <meta name="keywords" content="Avgas, cultivar, BeyondBloom, premium plants, greenhouse, growing excellence" />
        <meta name="author" content="BeyondBloom™" />
        <meta property="og:title" content="Avgas Cultivar - BeyondBloom™" />
        <meta property="og:description" content="Discover Avgas, a premium cultivar from BeyondBloom™. High-quality growth, innovation, and excellence in every bloom." />
        <meta property="og:image" content="/images/av-gas.png" />
        <meta property="og:url" content="https://yourwebsite.com/avgas" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Avgas Cultivar - BeyondBloom™" />
        <meta name="twitter:description" content="Discover Avgas, a premium cultivar from BeyondBloom™. High-quality growth, innovation, and excellence in every bloom." />
        <meta name="twitter:image" content="/images/av-gas.png" />
      </Helmet>
      <Navbar />
      <ProductShowcase />
      <FeatureHighlight />
      <CultivarDisplay />
      <Cta />
      <Footer />
    </>
  );
};

export default Avgas;
